module.exports = __webpack_public_path__ + "2acb60f2/img/send-icon.3cfb6275.svg";